module.exports = __webpack_public_path__ + "img/Ma.Maritime.Breakwaters.ConcreteArmourUnits-crownwall.Concrete.47b5e022.png";